import React from 'react';
import { StyleSheet, TextStyle } from 'react-native';
import { useTheme } from 'react-native-paper';
import {
  ActionSheetOptions,
  useActionSheet as useExpActionSheets,
} from '@expo/react-native-action-sheet';

import { windowHeight } from '@src/configuration/constants';

const styles = StyleSheet.create({
  container: {
    maxHeight: windowHeight * 0.8,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
  },
});

const staticOptions: ActionSheetOptions = {
  options: [],
  containerStyle: styles.container,
  cancelButtonIndex: 0,
  destructiveButtonIndex: 0,
  useModal: true,
};

const useActionSheets = () => {
  const { showActionSheetWithOptions } = useExpActionSheets();
  const theme = useTheme();
  return React.useMemo(() => {
    const textStyle: TextStyle = {
      fontFamily: theme.fonts.regular.fontFamily,
    };
    const titleTextStyle: TextStyle = {
      fontFamily: theme.fonts.medium.fontFamily,
    };
    return (options: ActionSheetOptions, callback: (i?: number) => void) => {
      requestAnimationFrame(() =>
        showActionSheetWithOptions(
          {
            ...staticOptions,
            textStyle: textStyle,
            titleTextStyle,
            messageTextStyle: textStyle,
            ...options,
          },
          callback
        )
      );
    };
  }, [
    showActionSheetWithOptions,
    theme.fonts.medium.fontFamily,
    theme.fonts.regular.fontFamily,
  ]);
};

export default useActionSheets;
